<template>
  <div class="h5-container">
    <div class="container-item">
      <!-- 背景图区域 -->
      <div class="bg-card">
        <img src="../../assets/img/h5/fair-join/20260624.png" alt="背景图" class="bg-img" />
      </div>

      <!-- 表单区域 -->
      <div class="form-card">
        <!-- 姓名 -->
        <van-field
            v-model="name"
            name="name"
            label="姓名"
            placeholder="请输入您的姓名"
            required
            @blur="trimName"
        />

        <!-- 电话 -->
        <van-field
            v-model="phone"
            name="phone"
            label="手机号"
            placeholder="请输入手机号"
            required
            @blur="trimPhone"
        />

        <!-- 地区：省-市 -->
        <van-field
            readonly
            clickable
            name="prefecture"
            label="城市"
            placeholder="请选择省-市"
            required
            v-model="prefecture"
            @click="showAreaPicker = true"
        />
        <van-popup v-model:show="showAreaPicker" position="bottom" :style="{ height: '30%' }">
          <van-area
              :area-list="areaList"
              :columns-num="2"
              @confirm="onAreaConfirm"
              @cancel="showAreaPicker = false"
          />
        </van-popup>

        <!-- 合作方向 多选 -->
        <!-- <van-field name="cooperateType" required label="合作方向">
          <template #input>
            <van-checkbox-group v-model="cooperateTypeArr" direction="horizontal" class="brand-group-cooperate">
              <van-checkbox name="想开璟点器材店">想开璟点器材店</van-checkbox>
              <van-checkbox name="想代理球杆产品">想代理球杆产品</van-checkbox>
              <van-checkbox name="想开球房买球桌">想开球房买球桌</van-checkbox>
            </van-checkbox-group>
          </template>
        </van-field> -->

        <!-- 合作品牌 多选 -->
        <!-- <van-field name="brand" required label="合作品牌" >
          <template #input>
            <van-checkbox-group v-model="brandArr" direction="horizontal" class="brand-group">
              <van-checkbox name="美洲豹">美洲豹</van-checkbox>
              <van-checkbox name="毒药">毒药</van-checkbox>
              <van-checkbox name="环球">环球</van-checkbox>
              <van-checkbox name="达芬尼">达芬尼</van-checkbox>
              <van-checkbox name="鬼斧">鬼斧</van-checkbox>
              <van-checkbox name="小怪兽">小怪兽</van-checkbox>
              <van-checkbox class="last-item" name="璟点台球桌">璟点台球桌</van-checkbox>
            </van-checkbox-group>
          </template>
        </van-field> -->

        <!-- ====================== 新增：备注框（非必填） ====================== -->
        <van-field
            v-model="remark"
            name="remark"
            placeholder="（选填）简单讲下您对台球的理解，以及对未来合作的期待与想法"
            type="textarea"
            :rows="3"
        />
      </div>

      <!-- 提交按钮 -->
      <van-button class="search-btn" block @click="getProgress">提交申请</van-button>
    </div>

    <!-- 🔥 提交成功全屏图片 -->
    <div v-if="showSuccessImage" class="success-image">
      <img src="@/assets/img/h5/fairJoinScusess.jpg" alt="提交成功">
    </div>
  </div>
</template>

<script>
import '@/assets/css/mobileGlobal.scss';
import { addFairJoin } from "@/api/fairJoin";
import { Toast} from "vant";
import { areaList } from '@vant/area-data';

export default {
  data() {
    return {
      name: '',
      phone: '',
      prefecture: '',
      cooperateTypeArr: [],
      brandArr: [],
      remark: '',
      showAreaPicker: false,
      areaList,
      showSuccessImage: false
    }
  },
  methods: {
    trimName() { this.name = this.name.trim(); },
    trimPhone() { this.phone = this.phone.trim(); },

    onAreaConfirm(value) {
      const province = value[0]?.name || '';
      const city = value[1]?.name || '';
      this.prefecture = `${province}-${city}`;
      this.showAreaPicker = false;
    },

    // validatePhone(phone) {
    //   if (!phone) return false;
    //   const reg = /^(1[3-9]\d{9})$|^(\d{8,12})$/;
    //   return reg.test(phone.trim());
    // },
    validatePhone(phone) {
      if (!phone) return false;
      // 纯中国大陆11位手机号严格校验
      const reg = /^1[3-9]\d{9}$/;
      return reg.test(phone.trim());
    },

    getProgress() {
      this.trimName();
      this.trimPhone();

      if (!this.name) { Toast('请输入姓名'); return; }
      if (!this.phone) { Toast('请输入手机号'); return; }
      if (!this.validatePhone(this.phone)) { Toast('请输入有效的手机号'); return; }
      if (!this.prefecture) { Toast('请选择城市'); return; }
      // if (this.cooperateTypeArr.length === 0) { Toast('请选择合作方向'); return; }
      // if (this.brandArr.length === 0) { Toast('请选择合作品牌'); return; }

      this.doSubmit();
    },

    async doSubmit() {
      const params = {
        name: this.name,
        phone: this.phone,
        prefecture: this.prefecture,
        cooperateType: this.cooperateTypeArr.join(','),
        brand: this.brandArr.join(','),
        remark: this.remark
      };

      try {
        const res = await addFairJoin(params);
        if (res.code === 200) {
          Toast.success('提交成功！我们会尽快与您联系');

          setTimeout(() => {
            this.showSuccessImage = true;
          }, 2000);

          this.name = '';
          this.phone = '';
          this.prefecture = '';
          this.cooperateTypeArr = [];
          this.brandArr = [];
          this.remark = '';
        } else {
          Toast(res.msg || '提交失败，请重试');
        }
      } catch (err) {
        Toast('网络异常，提交失败');
        console.error(err);
      }
    },
  }
}
</script>

<style scoped lang="scss">
$black: #000000;
$gold: #e01923;
$dark-gold: #B8860B;

/* 🔥 移动端输入框不放大修复 */
::v-deep input,
::v-deep textarea {
  font-size: 16px !important;
}

::v-deep .van-field{
  margin-bottom: 0 !important;
}

.brand-field {
  margin-top: 12px !important;
  ::v-deep .van-field__body {
    padding-top: 6px;
  }
}

/* 合作品牌样式 */
::v-deep .brand-group {
  display: flex;
  flex-wrap: wrap;
  padding: 6px 0;
  gap: 8px 16px;

  .van-checkbox {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    white-space: nowrap;
    width: 70px; /* 其他品牌宽度 */
  }

  /* 单独设置 璟点台球桌 宽度 */
  .van-checkbox.last-item {
    width: 110px !important;
  }
}

::v-deep .brand-group-cooperate {
  display: flex;
  flex-wrap: wrap;
  gap: 10px 16px;
  padding: 6px 0;
}

.h5-container {
  position: relative;
  background-color: #fdfdfd;
  @media (min-width: 768px) {
    width: 50%;
    margin: 0 auto;
    min-height: 110vh;
    background-color: #fdfdfd;
  }
}
.container-item {
  margin-bottom: 60px;
  @media (min-width: 768px) {
    padding: 0 20px;
    margin-bottom: 42px;
  }
}

.bg-card {
  overflow: hidden;
  box-sizing: border-box;
  @media (min-width: 768px) {
    height: 400px;
    border-radius: 12px;
    margin: 20px auto;
  }
}
.bg-img {
  width: 100%;
  height: auto;
  display: block;
  @media (min-width: 768px) {
    min-height: 400px;
    object-fit: cover;
  }
}

.form-card {
  background: #fff;
  padding: 16px;
  margin-bottom: 20px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  @media (min-width: 768px) {
    padding: 25px;
    margin: 0 auto 30px;
    width: calc(100% - 40px);
    border-radius: 15px;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  }
}

.search-btn {
  width: 100%;
  height: 48px;
  border-radius: 10px;
  //background: #854e40;
  background: linear-gradient(135deg, #D4AF37 0%, #B8860B 100%);
  color: #FFFFFF;
  font-size: 16px;
  font-weight: bold;
  border: none;
  margin-bottom: 16px;
  @media (min-width: 768px) {
    height: 80px;
    font-size: 36px;
    border-radius: 12px;
    margin: 0 auto 30px;
    width: calc(100% - 40px);
    &:hover {
      background: #c01520;
      cursor: pointer;
    }
  }
}

::v-deep .van-dialog__confirm {
  color: #E01923 !important;
  @media (min-width: 768px) {
    font-size: 20px !important;
    padding: 0 30px !important;
  }
}
::v-deep .van-dialog__cancel {
  @media (min-width: 768px) {
    font-size: 20px !important;
    padding: 0 30px !important;
  }
}
::v-deep .van-dialog__title {
  @media (min-width: 768px) {
    font-size: 24px !important;
    margin-bottom: 15px !important;
  }
}
::v-deep .van-dialog__message {
  @media (min-width: 768px) {
    font-size: 20px !important;
    line-height: 1.6 !important;
  }
}

::v-deep .van-toast {
  @media (min-width: 768px) {
    font-size: 20px !important;
    padding: 15px 25px !important;
    border-radius: 10px !important;
  }
}

/* 🔥 提交成功全屏图片：无上下空隙，完全铺满 */
.success-image {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 9999;
  overflow: hidden; /* 裁切超出部分，保证无空隙 */
}
.success-image img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  object-fit: cover; /* 关键：铺满屏幕，按比例裁切超出部分 */
  display: block;
}

</style>